export enum FormationGroupType {
  Aircraft = 'Aircraft',
}
